'use strict';
angular.module('mean.accounting').controller('TransactionController',
    ['$scope', 'Global', 'MeanUser', 'Projects', '$http', '$filter', 'commonConstant', 'ReconcileService', 'ProjectTasks', 'Trades', 'aceUtils', 'tradeCodeService', 'Customers', 'VendorService', 'Charts', 'userService', 'ngDialog', 'accountingConstant', 'TransactionService', 'TransactionBillsService', 'toaster', 'Users',
        function ($scope, Global, MeanUser, Projects, $http, $filter, commonConstant, ReconcileService, ProjectTasks, Trades, aceUtils, tradeCodeService, Customers, VendorService, Charts, userService, ngDialog, accountingConstant, TransactionService, TransactionBillsService, toaster, Users) {
            var accountType = accountingConstant.accountType;
            $scope.global = Global;
            $scope.user = MeanUser.user;
            $scope.main_accountId = '';
            $scope.companyName = '';
            $scope.filterDates = { startDate: null, endDate: null };
            $scope.users_trade_account = {};
            $scope.commonConstant = commonConstant;
            $scope.reconRefOpt = accountingConstant.reconRefrence;
            $scope.selAccountId = null;
            $scope.selReconcilate = null;
            $scope.reconReasons = accountingConstant.reconReasons;
            $scope.missingReasons = accountingConstant.missingReasons;
            $scope.selectedTabs = 'transaction';
            $scope.recDetailView = false;
            $scope.recFirstSection = false;
            $scope.recSecondSection = false;
            $scope.minimumEndDate = null;
            $scope.reconcileData = [];
            $scope.reconcileTrans = [];
            $scope.missingACTrans = [];
            $scope.accounts = [];
            $scope.customers = [];
            $scope.senderEmail = [];
            $scope.users = [];
            $scope.vendors = [];
            $scope.selFilter = {};
            $scope.just_print = true;
            $scope.allChecked = true;
            $scope.minDateMoment = moment();
            $scope.datepicker = moment().subtract(1, 'days');
            $scope.reportDateRange = { startDate: null, endDate: null };
            $scope.rangeOption = [
                { label: 'All', dateRange: [] },
                { label: 'This Year to Date', dateRange: [moment().startOf('year'), moment().endOf('day')] },
                { label: 'This Year', dateRange: [moment().startOf('year'), moment().endOf('year')] },
                { label: 'This Quarter to Date', dateRange: [moment().startOf('quarter'), moment().endOf('day')] },
                { label: 'This Quarter', dateRange: [moment().startOf('quarter'), moment().endOf('quarter')] },
                { label: 'This Month to Date', dateRange: [moment().startOf('month'), moment().endOf('day')] },
                { label: 'This Month', dateRange: [moment().startOf('month'), moment().endOf('month')] },
                { label: 'This Week', dateRange: [moment().subtract(7, 'days'), moment().endOf('day')] },
                { label: 'Today', dateRange: [moment().startOf('day'), moment().endOf('day')] },
                { label: 'Custom', dateRange: [] }
            ]
            $scope.reconcRangeOption = angular.copy($scope.rangeOption);
            $scope.reconcRangeOption.shift();
            $scope.selFilter = {
                selRange: $scope.rangeOption[0]
            };

            $scope.reportDateRange = { startDate: null, endDate: null };
            $scope.showRangeOption = false;
            $scope.reportRangeOptions = {
                locale: { format: "MM/DD/YYYY" },
                separator: ' - ',
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function (ev, picker) {
                        const dateObje = angular.copy(ev.model);
                        $scope.dateRangeUpdated([dateObje.startDate, dateObje.endDate]);
                    }
                }
            };
            $scope.selectedRange = moment().startOf('year').format('MM/DD/YYYY') + ' - ' + moment().endOf('day').format('MM/DD/YYYY');
            $scope.vendorTermsType = accountingConstant.vendorTerms;
            $scope.preferredAccountType = accountingConstant.preferredAccount;
            $scope.reoccurringType = accountingConstant.reoccurringType;
            $scope.transactionType = accountingConstant.transactionType;
            $scope.transactionGroupModals = accountingConstant.transactionModal;
            $scope.transactionGroupModal = false;
            $scope.jobTypePhase = $scope.lot = $scope.Plan = $scope.task = ['NA'];
            $scope.billError = false;
            $scope.all_tasks = [];
            $scope.all_projects = [];
            $scope.task_selector = [];
            $scope.phase_selector = [];
            $scope.lot = $scope.Plan = $scope.task = ['NA'];
            $scope.lots = [];
            $scope.task_codes = [];
            $scope.jobTypes = ['Contract', 'Options', 'Extras'];
            var importTransactionsAPI = '/api/accounting/importTransactions';
            $scope.pdfHeadings = {
                date: 'Date', transaction: 'Transaction Type', fromName: 'Name', debitAccount: 'Debit Account', toName: 'Name', creditAccount: 'Credit Account', refNo: 'Ref No', memo: 'Memo', amount: 'Amount'
            };

            $scope.minDate = moment().startOf('year');
            $scope.maxDate = moment().endOf('day');

            $scope.recFilter = {
                account: '',
                sdate: '',
                beginBal: 0.00,
                closingBal: 0.00,
                edate: '',
                debitIncrease: false
            };

            $scope.reconcilateData = angular.copy(accountingConstant.reconcilateData);

            $scope.reconciliationData = null;

            $scope.emailPopup = function () {
                $scope.senderEmail = [''];
                ngDialog.openConfirm({
                    template: 'accounting/views/transactions/modals/emails.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                    width: 400
                }).then(function (emails) {
                    if (emails.length) {
                        $scope.just_print = false;
                        $scope.buildPDF();
                    }
                }, function () {
                    $scope.senderEmail = [];
                });
            }

            $scope.addMoreEmails = function () {
                $scope.senderEmail.push('');
            }

            $scope.removeEmails = function (index) {
                $scope.senderEmail.splice(index, 1);
            }

            $scope.addTransaction = function () {
                $scope.transactionGroupModal = true;
            }

            $scope.reconciliation = function () {
console.log('reconciliation');
                if ($scope.recFilter.account === '' || !$scope.recFilter.account) {
                    toaster.pop('error', 'Error', 'Select account name.');
                    return;
                }

                if ($scope.recFilter.edate === '' || !$scope.recFilter.edate) {
                    toaster.pop('error', 'Error', 'Select end date.');
                    return;
                }

                if ($scope.recFilter.closingBal === '') {
                    toaster.pop('error', 'Error', 'Enter closing balance.');
                    return;
                }

                var selEndDate = $scope.recFilter.edate;
                if ($scope.minimumEndDate != null && selEndDate.isSame(moment($scope.minimumEndDate)) || moment($scope.minimumEndDate).isAfter(selEndDate)) {
                    toaster.pop('error', 'Error', 'Select date after ' + moment($scope.minimumEndDate).format('MM/DD/YYYY'));
                    $scope.recFilter.edate = '';
                    return;
                }

                $scope.selAccountId = $scope.recFilter.account._id;

                var debitAccountIncrease = (accountType[0].name === $scope.recFilter.account.parentOfAccountType)
                    || (accountType[0].name === $scope.recFilter.account.parentOfParentAccountType)
                    || (accountType[4].name === $scope.recFilter.account.parentOfAccountType)
                    || (accountType[4].name === $scope.recFilter.account.parentOfParentAccountType);

                $scope.recFilter.debitIncrease = debitAccountIncrease;

                var newObject = {
                    clientAccountId: $scope.main_accountId,
                    startDate: moment($scope.recFilter.sdate).startOf('day').toDate(),
                    endDate: moment($scope.recFilter.edate).endOf('day').toDate(),
                    accountId: $scope.recFilter.account._id,
                    begningBalance: $scope.recFilter.beginBal,
                    closingBalance: $scope.recFilter.closingBal,
                    refrenceTransactions: [],
                    missingTransactions: []
                };

                newObject.startDate.setHours(0);
                newObject.startDate.setMinutes(0);
                newObject.startDate.setSeconds(0);
                newObject.startDate.setMilliseconds(0);

                newObject.endDate.setHours(0);
                newObject.endDate.setMinutes(0);
                newObject.endDate.setSeconds(0);
                newObject.endDate.setMilliseconds(0);

                var newRecon = new ReconcileService(newObject);

                newRecon.$save(function (savedDoc) {
                    $scope.selReconcilate = savedDoc;
                    $scope.getReconTransactions();
                });
            }

            $scope.onEndDateChange = function (selDate) {

                if ($scope.recFilter.account === '' || !$scope.recFilter.account) {
                    toaster.pop('error', 'Error', 'Select account name for opening balance.');
                    $scope.recFilter.edate = '';
                    return;
                }
            }

            $scope.fetchReconReport = function () {
                var payload = {
                    'clientAccountId': $scope.main_accountId,
                    'accountId': $scope.selFilter.account ? $scope.selFilter.account._id : null,
                    'type': 'populateAccount',
                    'startDate': $scope.startDate ? $scope.startDate : undefined,
                    'endDate': $scope.endDate ? $scope.endDate : undefined
                }
                ReconcileService.query(payload, function (data) {
                    _.each(data, function(item) {
                        item.endDate = new Date(item.endDate);
                    });
                    $scope.reconcileData = data;
                    $scope.recSecondSection = true;
                });
            }

            $scope.changeReconcileAC = function (selAcccount) {
                if (selAcccount.createdDate) {
console.log('changeReconcileAC');
                    $scope.recFilter.sdate = null;
                    $scope.recFilter.beginBal = 0;
                    $scope.minimumEndDate = null;
                    $scope.recFilter.closingBal = 0;
                    $scope.recFilter.edate = null;
                    $scope.reconcileTrans = [];
                    $scope.selReconcilate = null;
                    ReconcileService.query({
                        'clientAccountId': $scope.main_accountId,
                        'accountId': selAcccount._id
                    }, function (data) {
                        if (data.length) {
                            _.each(data, function(item) {
                                item.endDate = new Date(item.endDate);
                            });

                            data = $filter('orderBy')(data, '-endDate');
                            $scope.recFilter.sdate = moment(data[0].endDate).add(1, 'days').startOf('day').toDate();
                            $scope.recFilter.beginBal = data[0].closingBalance;
                            $scope.minimumEndDate = moment(data[0].endDate);
                        } else {
                            var searchProperties = {
                                paymentAccounts: selAcccount._id,
                                clientAccountId: $scope.main_accountId,
                                isDeleted: false
                            }
                            TransactionService.query(searchProperties, function (transaction) {
                                var firstTransaction = _.sortBy(transaction, ['date']);
                                $scope.recFilter.beginBal = 0.00;
                                if (firstTransaction.length) {
                                    $scope.recFilter.sdate = moment(firstTransaction[0].date).startOf('day').toDate();
                                } else {
                                    $scope.recFilter.sdate = moment(selAcccount.asOf).startOf('day').toDate();
                                }
                            });
                        }
                    });
                }
            }

            $scope.changeSelection = function () {
                if ($scope.selFilter.selRange.dateRange.length > 0) {
                    $scope.showRangeOption = false;
                    $scope.selectedRange = moment($scope.selFilter.selRange.dateRange[0]).format('MM/DD/YYYY') + ' - ' + moment($scope.selFilter.selRange.dateRange[1]).format('MM/DD/YYYY');
                    $scope.dateRangeUpdated($scope.selFilter.selRange.dateRange);
                } else {
                    $scope.showRangeOption = true;
                    $scope.startDate = ''
                    $scope.endDate = ''
                }
            }

            $scope.dateRangeUpdated = function (ranges) {
                if (!ranges.length) return;

                $scope.startDate = new Date(ranges[0]);
                $scope.endDate = new Date(ranges[1]);

                $scope.startDate.setHours(0);
                $scope.startDate.setMinutes(0);
                $scope.startDate.setSeconds(0);
                $scope.endDate.setHours(23);
                $scope.endDate.setMinutes(59);
                $scope.endDate.setSeconds(59);
            };

            $scope.just_print = false;

            $scope.init = function () {
                userService.getMainAccountId($scope.user.username).then(function (id) {
                    $scope.main_accountId = id;
                    $scope.getAccounts();
                    $scope.getVendors();
                    $scope.getCustomers();
                    Trades.query({ 'main_account_id': $scope.main_accountId }, function (trade) {
                        $scope.users_trade_account = trade[0];
                        trade[0].company_code = aceUtils.padDigits(trade[0].company_code, 3);
                        trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                        Projects.query({
                            'company_code': trade[0].company_code,
                            'trade_code': trade[0].trade_code
                        }, function (projects) {
                            $scope.all_projects = projects;
                        });
                        Users.query({ 'trade': $scope.user.trade[0], 'contractor_code': $scope.user.contractor_code }, function (users) {
                            $scope.users = users;
                        });
                        userService.getCompanyName($scope.user.username).then(function (company) {
                            $scope.companyName = company;
                        });
                    });
                });
            };

            $scope.makeProjectTasks = function (project_id) {
                ProjectTasks.query({
                    'project_id': project_id
                }, function (tasks) {

                    $scope.all_tasks = tasks;
                    $scope.phase_selector = [];

                    _.each($scope.all_tasks, function (task) {
                        if (task.status === 'finished') return;

                        task.name = task.division.name;
                        var in_phase = $filter('filter')($scope.phase_selector, { 'name': task.phase }, true);

                        if (in_phase.length === 0) {

                            //build task_selector for the view
                            var code = [];
                            code.push({
                                name: task.task_code,
                                finished: task.status,
                                full_name: task.task_name
                            });

                            var lot = [];
                            lot.push({
                                name: task.lot,
                                task_codes: code,
                                plan_code: task.plan_code
                            });

                            $scope.phase_selector.push({
                                name: task.phase,
                                lot: lot
                            });
                        } else {
                            //we've already added this job_text to the list
                            //so we need to figure out if we need to add a phase or a lot
                            var found = false;
                            for (var i = 0; i < in_phase.length; i = i + 1) {
                                if (in_phase[i].name === task.phase) {
                                    found = true;
                                    var lot_found = false;
                                    var lot_index = 0;
                                    //we found the phase so lets see if we have this lot
                                    for (var j = 0; j < in_phase[i].lot.length; j = j + 1) {
                                        if (in_phase[i].lot[j].name === task.lot) {
                                            lot_found = true;
                                            lot_index = j;
                                        }
                                    }

                                    if (!lot_found) {
                                        var code = [];
                                        code.push({
                                            name: task.task_code,
                                            finished: task.status,
                                            full_name: task.task_name
                                        });

                                        in_phase[i].lot.push({
                                            name: task.lot,
                                            task_codes: code,
                                            plan_code: task.plan_code
                                        });
                                    } else {
                                        var task_found = false;
                                        for (var k = 0; k < in_phase[i].lot[lot_index].task_codes.length; k = k + 1) {
                                            if (in_phase[i].lot[lot_index].task_codes[k].name === task.task_codes) {
                                                task_found = true;
                                            }
                                        }

                                        if (!task_found) {
                                            in_phase[i].lot[lot_index].task_codes.push({
                                                name: task.task_code,
                                                finished: task.status,
                                                full_name: task.task_name
                                            });
                                        }
                                    }
                                }
                            }

                            if (!found) {
                                //the phase was not found so add the task_code, lot, and phase
                                var code = [];
                                code.push({
                                    name: task.task_code,
                                    finished: task.status,
                                    full_name: task.task_name
                                });

                                $scope.phase_selector.push({
                                    name: task.phase,
                                    lot: [{
                                        name: task.lot,
                                        task_codes: code,
                                        plan_code: task.plan_code
                                    }]
                                });
                            }

                        }
                    });

                });
            };

            $scope.phaseChange = function () {
                $scope.transaction.expense.map(item => {
                    item['lot'] = 'NA';
                    item['plan'] = 'NA';
                    item['task'] = 'NA';
                    item['lists'] = ['NA'];
                    return item;
                });
            }

            $scope.lotsChange = function (lot, index) {
                $scope.transaction.expense[index]['plan'] = lot.plan_code;
                $scope.transaction.expense[index]['lists'] = lot.task_codes;
            }

            $scope.getResults = function () {
                if ($scope.selFilter) {
                    var searchProperties = {
                        transactionType: $scope.selFilter.transactionType,
                        paymentAccounts: $scope.selFilter.accountType ? $scope.selFilter.accountType._id : undefined,
                        payee: $scope.selFilter.vendor ? $scope.selFilter.vendor._id : undefined,
                        customer: $scope.selFilter.customer ? $scope.selFilter.customer._id : undefined,
                        startDate: $scope.startDate ? $scope.startDate : undefined,
                        endDate: $scope.endDate ? $scope.endDate : undefined,
                        clientAccountId: $scope.main_accountId,
                        isDeleted: false
                    }
                }
                searchProperties.clientAccountId = $scope.main_accountId;
                TransactionService.query(searchProperties, function (transaction) {
                    $scope.applyUniqueFilter(transaction);
                });
            }

            $scope.applyUniqueFilter = function (transaction) {

                transaction = transaction.map(function (singleAc) {

                    var payments = angular.copy(singleAc.paymentAccounts);
                    var expenses = angular.copy(singleAc.expense);

                    var uniquePayments = _.unionBy(payments, 'name');
                    var uniqueExpenses = _.unionBy(expenses, 'name');

                    uniquePayments = uniquePayments.map(function (singleItem) {
                        singleItem['paymentAmount'] = 0;
                        singleItem['diffAmt'] = 0;
                        return singleItem;
                    });

                    uniqueExpenses = uniqueExpenses.map(function (singleItem) {
                        singleItem['expenseAmount'] = 0;
                        singleItem['paidAmount'] = 0;
                        singleItem['diffAmt'] = 0;
                        return singleItem;
                    });

                    _.each(uniquePayments, function (uniquePayment) {
                        _.each(singleAc.paymentAccounts, function (singlePayment) {
                            if (uniquePayment['name'] === singlePayment['name']) {
                                uniquePayment['paymentAmount'] += singlePayment['paymentAmount'];
                                uniquePayment['diffAmt'] += singlePayment['diffAmt'];
                            }
                        });
                    });

                    _.each(uniqueExpenses, function (uniqueExpense) {
                        _.each(singleAc.expense, function (singleExpense) {
                            if (uniqueExpense['name'] === singleExpense['name']) {
                                uniqueExpense['expenseAmount'] += singleExpense['expenseAmount'];
                                uniqueExpense['paidAmount'] += singleExpense['paidAmount'];
                                uniqueExpense['diffAmt'] += singleExpense['diffAmt'];
                            }
                        });
                    });

                    singleAc['uniquePayments'] = uniquePayments;
                    singleAc['uniqueExpenses'] = uniqueExpenses;

                    return singleAc;
                });
                $scope.transactionList = transaction;
            }

            $scope.transactionModal = (type) => {
                OnTransactionModal(type);
                ngDialog.openConfirm({
                    template: 'accounting/views/transactions/modals/transactions_modal.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                    width: type.modal === 'Customer' ? 1000 : 900,
                    onOpenCallback: function () {
                        $scope.modalOpen = {
                            isOpen: false
                        }
                        setTimeout(function () {
                            angular.element(':focus').blur();
                        })
                    }
                }).then(function (value) {
                    console.log($scope.modalType);
                    console.log(value);

                    if ($scope.modalType === 'PayBill' || $scope.modalType === 'PayPayrollBill' || $scope.modalType === 'ReceivePayment') {
                        if (value.bills.length) {
                            var billsUpdate = {
                                bills: billUpdateTransaction(value)
                            }

                            TransactionBillsService.update(billsUpdate).$promise.then(function () {

                                if ($scope.modalType === 'PayBill' || $scope.modalType === 'PayPayrollBill') {

                                    createMultipleTransaction(value);
                                }
                                if ($scope.modalType === 'ReceivePayment') {
                                    var payBillPayment = []
                                    value.bills.map(function (item) {
                                        payBillPayment.push({
                                            transactionId: item._id,
                                            paidAmount: item.totalPayAmount
                                        })
                                    })
                                    var invoicePayment = value.bills[0];
                                    delete invoicePayment._id;
                                    delete invoicePayment.dueDate;
                                    delete invoicePayment.createdDate;
                                    invoicePayment.payBillPayment = payBillPayment;
                                    invoicePayment.transactionType = $scope.modalType;
                                    invoicePayment.paymentAccounts = [{
                                        name: invoicePayment.expense[0].expenseAccount.name,
                                        paymentAccount: invoicePayment.expense[0].expenseAccount,
                                        paymentAmount: value.totalPaymentAmount1
                                    }],
                                        invoicePayment.paymentType = value.paymentType;
                                    invoicePayment.totalExpenseAmount = value.totalPaymentAmount1;
                                    invoicePayment.date = value.date;
                                    invoicePayment.referenceNo = value.referenceNo;
                                    invoicePayment.totalPaymentAmount = value.totalPaymentAmount1;
                                    if (invoicePayment.expense) {
                                        invoicePayment.expense.map(function (expense) {
                                            expense.name = value.paymentAccount.name
                                            expense.expenseAccount = value.paymentAccount._id;
                                            expense.expenseAmount = value.totalPaymentAmount1;
                                        })
                                    }
                                    TransactionService.save(invoicePayment).$promise.then(function () {
                                        toaster.pop('success', 'Added', 'Transaction Added Successfully.');
                                        $scope.getResults();
                                        $scope.transactionGroupModal = false;
                                        $scope.transaction.trans = '';
                                        $scope.payBills = [];
                                    })

                                }
                            })
                        } else {
                            createTransactionWithoutInvoice(value);
                        }
                    } else {
                        if (value.reoccurring) {
                            value.reoccurringDate = getReoccuringDate(value);
                        }
                        createTransaction(value);
                        $scope.transactionGroupModal = false;
                        $scope.transaction.trans = '';
                    }
                },
                    function () {
                        $scope.getResults();
                        $scope.transactionGroupModal = false;
                        $scope.transaction.trans = '';
                        $scope.payBills = [];
                    });
            };

            function createTransactionWithoutInvoice(value) {
                if ($scope.modalType === 'ReceivePayment') {
                    var invoicePayment = value;
                    invoicePayment.transactionType = $scope.modalType;
                    invoicePayment.clientAccountId = $scope.main_accountId;
                    invoicePayment.clientAccountId = $scope.user._id;
                    invoicePayment.transactionType = $scope.modalType;
                    invoicePayment.paymentAccounts = [{
                        name: $scope.expenseAccount[0].name,
                        paymentAccount: $scope.expenseAccount[0]._id,
                        paymentAmount: value.totalPaymentAmount1
                    }],
                        invoicePayment.paymentType = value.paymentType;
                    invoicePayment.totalExpenseAmount = value.totalPaymentAmount1;
                    invoicePayment.totalPaymentAmount = value.totalPaymentAmount1;
                    invoicePayment.expense = [{
                        name: value.paymentAccount.name,
                        expenseAccount: value.paymentAccount._id,
                        expenseAmount: value.totalPaymentAmount1
                    }];
                    invoicePayment.transactionRef = 'Customer';
                    TransactionService.save(invoicePayment).$promise.then(function () {
                        toaster.pop('success', 'Added', 'Transaction Added Successfully.');
                        $scope.getResults();
                        $scope.transactionGroupModal = false;
                        $scope.transaction.trans = '';
                        $scope.payBills = [];
                    })
                }
            }

            /**
             * @description Set values fo transaction on opening on transaction modal
             * @param {objec} type of transaction modal
             */
            function OnTransactionModal(type) {
                $scope.modalType = type.tranType;
                $scope.modalName = type.name;
                $scope.transRef = type.modal;
                $scope.transaction = {
                    project_id: '',
                    job: '',
                    phase: '',
                    expense: [{
                        expenseAccount: '',
                        expenseDescription: '',
                        expenseAmount: 0,
                        lot: 'NA',
                        plan: 'NA',
                        task: 'NA',
                        lists: ['NA']
                    }],
                    totalExpenseAmount: 0,
                    totalPaymentAmount: 0,
                    reoccurring: false,
                    payBills: [],
                    bills: [],
                    selectAllCheck: false,
                    isNew: true,
                    date: moment().subtract(1, 'days')
                };
                if ($scope.modalType === 'JournalEntry') {
                    $scope.transaction.expense = [
                        {
                            expenseAccount: '',
                            expenseDescription: '',
                            expenseAmount: 0,
                            paymentAmount: 0,
                            lot: '',
                            plan: '',
                            task: ''
                        },
                        {
                            expenseAccount: '',
                            expenseDescription: '',
                            expenseAmount: 0,
                            paymentAmount: 0,
                            lot: '',
                            plan: '',
                            task: ''
                        }
                    ]
                }

                if ($scope.modalType === 'PayBill' || $scope.modalType === 'PayPayrollBill') {
                    var transactionType = $scope.modalType === 'PayBill' ? 'Bill' : 'PayrollBill';
                    TransactionBillsService.query({ clientAccountId: $scope.main_accountId, isPaid: false, transactionType: transactionType }, function (bills) {
                        $scope.payBills = bills;
                        $scope.payBills.map(function (bills) {
                            var expenseAmount = angular.copy(bills.totalExpenseAmount),
                                paidAmount = angular.copy(bills.totalPaymentAmount),
                                calculatedAmount = paidAmount > 0 ? expenseAmount - paidAmount : expenseAmount;

                            bills.totalPayAmount = angular.copy(calculatedAmount);
                            bills.OpenBalance = angular.copy(calculatedAmount);
                        })
                    });
                }
                var currentCharQuery = {
                    type: 'TRAN_ACCOUNT',
                    isDeleted: false,
                    status: 'Active',
                    userId: $scope.main_accountId
                },
                    expenseAccount = angular.copy(currentCharQuery);
                $scope.transaction.errorCurrent = false;
                $scope.transaction.errorExpense = false;
                if ($scope.transRef === 'Customer') {
                    currentCharQuery.parentOfAccountType = 'Current Assets';
                    if ($scope.modalType === 'Invoice') {
                        currentCharQuery.accountType = 'Account Receivable';
                        currentCharQuery.systemGenrated = true;
                    }
                }
                if ($scope.transRef === 'Vendor' || $scope.transRef === 'Employee' || $scope.modalType === 'PayrollBill') {
                    delete currentCharQuery.systemGenrated;
                    currentCharQuery.accountType = ['Bank', 'Credit Card'];
                    if ($scope.modalType === 'Bill' || $scope.modalType === 'PayrollBill') {
                        delete currentCharQuery.accountType;
                        currentCharQuery.accountType = 'Accounts Payable';
                        currentCharQuery.systemGenrated = true;
                    }
                }
                // Get current Account
                Charts.query(currentCharQuery, function (accounts) {
                    var accounts = _.sortBy(accounts, ({ name }) => name.toLowerCase());
                    $scope.currentAccounts = accounts;
                    if ($scope.currentAccounts.length < 1) {
                        $scope.transaction.errorCurrent = true;
                    }
                });

                if ($scope.transRef === 'Vendor') {
                    expenseAccount.parentOfAccountType = 'Expenses';
                    if ($scope.modalType === 'Check'){
                        delete expenseAccount.parentOfAccountType;
                    }
                    if ($scope.modalType === 'PayBill') {
                        delete expenseAccount.parentOfAccountType;
                        expenseAccount.accountType = 'Accounts Payable';
                        expenseAccount.systemGenrated = true;
                    }
                }
                if ($scope.transRef === 'Customer') {
                    expenseAccount.parentOfAccountType = 'Income';
                    expenseAccount.systemGenrated = true;
                }

                // Get current expense account
                Charts.query(expenseAccount, function (accounts) {
                    var accounts = _.sortBy(accounts, ({ name }) => name.toLowerCase());
                    if ($scope.transRef !== 'Other') {
                        accounts = accounts.filter(function(item){
                            return item.detailType !== 'Retained Earnings'
                        });
                    }
                    $scope.expenseAccount = accounts;
                    if ($scope.expenseAccount.length < 1) {
                        $scope.transaction.errorExpense = true;
                    }
                });
            }

            $scope.updateExpenseAmount = (creditAmount, index) => {
                if ($scope.transaction.expense.length) {
                    $scope.transaction.totalExpenseAmount = $scope.transaction.expense.reduce(
                        (acc, cur) => accurateCalc(Number(acc), Number(cur.expenseAmount)), 0
                    );
                }
                if ($scope.modalType === 'JournalEntry') {
                    $scope.transaction.expense[index].debitDisable = !!Number(creditAmount);
                }
            }

            $scope.updatePaymentAmount = (paymentAmount, index) => {
                if ($scope.transaction.expense.length) {
                    $scope.transaction.totalPaymentAmount = $scope.transaction.expense.reduce(
                        (acc, cur) => accurateCalc(Number(acc), Number(cur.paymentAmount)), 0
                    );
                }
                $scope.transaction.expense[index].creditDisable = !!Number(paymentAmount);
            }

            $scope.selectAllCheck = (searchTerm) => {
                console.log('selectAllCheck');
                if ($scope.transaction.selectAllCheck) {
                    //var bills = $filter('filter')($scope.payBills,{'payee.name': searchTerm}, true);
                    $scope.transaction.bills = [];
                    $scope.payBills.forEach(function (item) { 
                        var add = false;
                        if(item.payee.name)
                            add = item.payee.name.toLowerCase().includes(searchTerm.toLowerCase());
                        else
                            add = item.project.name.toLowerCase().includes(searchTerm.toLowerCase());

                        if(add)
                            $scope.transaction.bills.push(item);
                    });
                } else {
                    $scope.transaction.bills.splice(0, $scope.transaction.bills.length);
                }
                $scope.totalAmountPaid();
            }
            $scope.totalAmountPaid = function () {
                $scope.transaction.totalPaymentAmount1 = $scope.transaction.bills.reduce(
                    (acc, cur) => Number(acc) + Number(cur.totalPayAmount), 0
                );
                //$scope.transaction.selectAllCheck = $scope.payBills.length === $scope.transaction.bills.length;
            }
            $scope.updateTerm = function () {
                if ($scope.transaction.payee) {
                    $scope.transaction.terms = $scope.transaction.payee.terms;
                    $scope.transaction.dueDate = moment($scope.transaction.payee.asOf);
                    if (!$scope.transaction.payee.asOf) {
                        $scope.updateDueDate();
                    }
                }
            }

            $scope.updateTermCustomer = function () {
                if ($scope.transaction.customer) {
                    $scope.transaction.terms = $scope.transaction.customer.terms;
                    $scope.transaction.dueDate = moment($scope.transaction.customer.asOf);
                    $scope.transaction.jobTypePhase = $scope.jobTypePhase[0];
                    $scope.transaction.expense[0].lot = $scope.lot[0];
                    $scope.transaction.expense[0].plan = $scope.Plan[0];
                    $scope.transaction.expense[0].task = $scope.task[0];
                    var transactionType = 'Invoice'
                    TransactionBillsService.query({ clientAccountId: $scope.main_accountId, isPaid: false, transactionType: transactionType, customer: $scope.transaction.customer._id }, function (bills) {
                        $scope.payBills = bills;
                        $scope.payBills.map(function (bills) {
                            var expenseAmount = angular.copy(bills.totalExpenseAmount),
                                paidAmount = angular.copy(bills.totalPaymentAmount),
                                calculatedAmount = paidAmount > 0 ? expenseAmount - paidAmount : expenseAmount;

                            bills.totalPayAmount = angular.copy(calculatedAmount);
                            bills.OpenBalance = angular.copy(calculatedAmount);
                        })

                    });
                }
            }

            $scope.selectedProject = function (project_id) {
                $scope.makeProjectTasks(project_id);
            }

            $scope.addMoreLine = () => {
                $scope.transaction.expense.push({
                    expenseAccount: null,
                    expenseDescription: null,
                    expenseAmount: '',
                    paymentAmount: '',
                    lot: '',
                    plan: '',
                    task: ''
                });
            }

            $scope.changeValue = function () {
                $scope.transaction.reoccurring = this.transaction.reoccurring;
            }

            $scope.deleteExpenseItem = (deleteIndex) => {
                $scope.transaction.expense.splice(deleteIndex, 1);
                $scope.updateExpenseAmount();
            }

            $scope.getAccounts = function () {
                Charts.query({ type: 'TRAN_ACCOUNT', isDeleted: false, status: 'Active', userId: $scope.main_accountId }, function (results) {
                    var accounts = _.sortBy(results, ({ name }) => name.toLowerCase());
                    $scope.accounts = accounts;
                    $scope.accountOptions($scope.accounts);
                });
            }

            $scope.accountOptions = function (accounts) {
                $scope.accountOption = [];
                accountingConstant.accountType.map(function (item) {
                    var filterTransaction = accounts.filter(function (transItem) {
                        return item.name === transItem.parentOfAccountType || item.name === transItem.parentOfParentAccountType;
                    })
                    filterTransaction.map(function (chart) {
                        chart.groupBy = item.name;
                    })
                    filterTransaction = _.sortBy(filterTransaction, ({ name }) => name.toLowerCase());
                    $scope.accountOption = $scope.accountOption.concat(filterTransaction);

                });
            }

            $scope.getVendors = function () {
                VendorService.query({ type: 'All', isDeleted: false, status: 'Active', userId: $scope.main_accountId }, function (results) {
                    var vandors = _.sortBy(results, ({ name }) => name.toLowerCase());
                    $scope.vendors = vandors;
                });
            }

            $scope.getCustomers = function () {
                Customers.query({ isDeleted: false, status: 'Active', userId: $scope.main_accountId }, function (results) {
                    var customers = _.sortBy(results, ({ name }) => name.toLowerCase());
                    $scope.customers = customers;
                });
            }

            $scope.onSelect = function (tab) {
                $scope.selectedTabs = tab;
                $scope.recDetailView = false;
                $scope.transactionList = [];
                $scope.recFilter = {
                    account: '', sdate: '', beginBal: 0.00,
                    closingBal: 0.00, edate: ''
                };
                $scope.reconcileTrans = [];
                $scope.selReconcilate = null;
                $scope.selFilter.selRange = $scope.selectedTabs !== 'reconcilation' ? $scope.rangeOption[0] : $scope.reconcRangeOption[0];
                if ($scope.selectedTabs === 'reconcilation') {
                    $scope.startDate = moment().startOf('year').toDate();
                    $scope.endDate = moment().endOf('day').toDate();
                }
            }

            $scope.recBackView = function (tab) {
                $scope.recDetailView = true;
            }

            /**
             * @description generate current month dates
             */
            $scope.reoccurringWatch = function () {
                if ($scope.transaction.reoccurringType.Type == 'M' || $scope.transaction.reoccurringType.Type == 'Y') {
                    if ($scope.transaction.reoccurringType.Type === 'Y') {
                        var monthsList = moment.months();
                        $scope.monthsList = monthsList.map((month, index) => {
                            var monthObj = {};
                            monthObj.id = index;
                            monthObj.month = month;
                            return monthObj
                        })
                    }
                    if ($scope.transaction.reoccurringType.key === 'twicePerMonth') {
                        $scope.firstFiftenDates = new Array(15).fill(null).map((date, index) => {
                            var dateObj = {}
                            dateObj.date = index + 1;
                            dateObj.id = index;
                            return dateObj;
                        })
                        $scope.secondFiftenDates = new Array(15).fill(null).map((date, index) => {
                            var dateObj = {}
                            dateObj.date = 16 + index;
                            dateObj.id = 15 + index;
                            return dateObj;
                        })
                    }
                    var daysInMonth = new Array(30).fill(null);
                    $scope.currentMonthDates = daysInMonth.map((x, i) => {
                        var dateObj = {}
                        dateObj.date = i + 1;
                        dateObj.id = i;
                        return dateObj;
                    });
                }
            }

            $scope.weekDays = moment.weekdays().map((weekday, index) => {
                var weekObj = {};
                weekObj.id = index;
                weekObj.weekday = weekday;
                return weekObj
            })

            /**
             * @description retutn next transaction date
             * @returns transaction dates in array
             */
            function getReoccuringDate() {
                var reoccurringDate = [];
                if ($scope.transaction.reoccurringType) {
                    reoccurringDate = [];
                    if ($scope.transaction.weekDays) {
                        var selectedWeekDayNo = Number($scope.transaction.weekDays.id) - Number(moment().day());
                        selectedWeekDayNo = selectedWeekDayNo >= 0 ? selectedWeekDayNo : 7 + selectedWeekDayNo;
                        var weekDate = moment().add($scope.transaction.reoccurringType.Num, 'week').add(selectedWeekDayNo, 'days');
                        reoccurringDate.push(weekDate);
                    }
                    if ($scope.transaction.reoccurringDate) {
                        var monthdate = moment().startOf('month').add($scope.transaction.reoccurringType.Num, $scope.transaction.reoccurringType.Type).add($scope.transaction.reoccurringDate.id, 'days');
                        reoccurringDate.push(monthdate);
                    }
                    if ($scope.transaction.date1 && $scope.transaction.date2) {
                        reoccurringDate = [];
                        var nextMonth = moment().startOf('month').add(1, 'month'),
                            twicePerMonth1 = Number(moment().date()) <= 15 ? moment().startOf('month').add($scope.transaction.date2.id, 'days') : nextMonth.add($scope.transaction.date2.id, 'days'),
                            twicePerMonth2 = nextMonth.add($scope.transaction.date1.id, 'days');
                        moment().date() <= 15 ? reoccurringDate.push(twicePerMonth1, twicePerMonth2) : reoccurringDate.push(twicePerMonth2, twicePerMonth1);
                    }
                    if ($scope.transaction.reoccurringType.Type === 'Y' && $scope.transaction.month && $scope.transaction.reoccurringDate) {
                        reoccurringDate = [];
                        var nextYearDate = moment().startOf('year').add(1, 'year').add($scope.transaction.month.id, 'month').add($scope.transaction.reoccurringDate.id, 'days');
                        reoccurringDate.push(nextYearDate);
                    }
                }
                return reoccurringDate;
            }


            function transactionValueModify(value) {
                value.isPaid = true;
                if (!value.isNew && $scope.modalType !== 'Bill' && $scope.modalType !== 'PayrollBill') {
                    value.totalPaymentAmount = value.totalExpenseAmount;
                }
                if ($scope.transRef === 'Customer' && $scope.modalType != 'ReceivePayment') {
                    if ($scope.modalType === 'Invoice') {
                        if (value.isNew || value.phaseEdit) {
                            if(value.job) {
                                value.projectInfo = {
                                    projectID: value.job._id,
                                    name: value.job ? value.job.name : 'NA',
                                    phase: value.phase ? value.phase.name : 'NA',
                                    type: value.type
                                };
                            }
                        } else {
                            if (value.job) {
                                value.projectInfo = {
                                    projectID: value.job._id,
                                    name: value.job ? value.job.name : 'NA',
                                    phase: value.phase,
                                    type: value.type
                                };
                            }
                        }
                        value.isPaid = false
                    }
                    if (value.expense) {
                        if (value.isNew || value.phaseEdit) {
                            value.expense.map(function (item) {
                                item.expenseAccount = $scope.currentAccounts[0];
                                item.lot = item.lot ? item.lot.name: 'NA';
                            })
                        } else {
                            value.expense.map(function (item) {
                                item.expenseAccount = $scope.currentAccounts[0];
                            })
                        }
                    }
                    value.paymentAccount = $scope.expenseAccount[0];
                } 

                if ($scope.modalType !== 'ReceivePayment') {
                    if ($scope.modalType === 'Bill' || $scope.modalType === 'PayrollBill') {
                        value.paymentAccount = $scope.currentAccounts[0];
                        value.isPaid = false
                    }

                    if ($scope.modalType === 'Transfer') {
                        value.totalExpenseAmount = value.expense[0].expenseAmount;
                    }
                    if ($scope.modalType === 'JournalEntry') {
                        value.paymentAccounts = value.expense.filter(function (item, index) {
                            var paymentAccountCond = !!Number(item.paymentAmount) && Number(item.expenseAmount) == 0;
                            if ((item.paymentAmount == 0 && item.expenseAmount == 0)) {
                                paymentAccountCond = index == 0;
                            }
                            return paymentAccountCond;
                        })
                        value.paymentAccounts = value.paymentAccounts.map(function (item) {
                            const payment = {};
                            payment.name = item.expenseAccount.name
                            payment.paymentAccount = item.expenseAccount._id;
                            payment.paymentAmount = item.paymentAmount;
                            payment.description = item.expenseDescription;
                            return payment;
                        })
                        value.expense = value.expense.filter(function (item, index) {
                            var expenseAmountCond = !!Number(item.expenseAmount) && Number(item.paymentAmount) == 0;;
                            if ((item.paymentAmount == 0 && item.expenseAmount == 0)) {
                                expenseAmountCond = index != 0;
                            }
                            return expenseAmountCond;
                        })
                        value.expense.map(function (item) {
                            item.name = item.expenseAccount.name;
                            item.expenseAccount = item.expenseAccount._id;
                        });
                    } else {
                        value.paymentAccounts = [{
                            name: value.paymentAccount ? value.paymentAccount.name : null,
                            paymentAccount: value.paymentAccount ? value.paymentAccount._id : null,
                            paymentAmount: value.totalPaymentAmount > 0 ? value.totalPaymentAmount : value.totalExpenseAmount,
                        }]
                        value.expense.map(function (item) {
                            item.name = item.expenseAccount.name
                            item.expenseAccount = item.expenseAccount._id;
                        })
                    }
                }
                var transaction = {
                    clientAccountId: $scope.main_accountId,
                    userId: $scope.user._id,
                    transactionType: $scope.modalType,
                    transactionRef: $scope.transRef,
                    paymentAccounts: value.paymentAccounts,
                    paymentType: value.paymentType,
                    date: value.date,
                    payee: value.payee ? value.payee._id : null,
                    user: value.user ? value.user._id : null,
                    customer: value.customer ? value.customer._id : undefined,
                    project: value.projectInfo,
                    referenceNo: !!value.referenceNo ? value.referenceNo : !!value.checkNo ? value.checkNo : !!value.startingCheckNo ? value.startingCheckNo : null,
                    totalExpenseAmount: value.totalExpenseAmount,
                    totalPaymentAmount: value.totalPaymentAmount > 0 ? value.totalPaymentAmount : ($scope.modalType == 'Bill' || $scope.modalType == 'Invoice') ? value.totalPaymentAmount : value.totalExpenseAmount,
                    expense: $scope.modalType !== 'PayBill' ? value.expense : [],
                    memo: value.memo,
                    reoccurring: value.reoccurring,
                    reoccurringType: value.reoccurringType && value.reoccurring ? value.reoccurringType.key : undefined,
                    reoccurringDates: value.reoccurringType ? value.reoccurringDate : [],
                    terms: value.terms,
                    dueDate: value.dueDate ? value.dueDate.toDate() : null,
                    checkNo: value.checkNo,
                    startingCheckNo: value.startingCheckNo,
                    payBills: value.payBills,
                    isPaid: value.isPaid,
                    systemGenrated: value.systemGenrated
                };
                return transaction;
            }

            function createTransaction(value) {
                var transObj = transactionValueModify(value);
                var transaction = new TransactionService(transObj);
                transaction.$save(function () {
                    toaster.pop('success', 'Added', 'Transaction Added Successfully.');
                    $scope.getResults();
                    $scope.transactionGroupModal = false;
                    $scope.transaction.trans = '';
                    $scope.payBills = [];
                })
            }

            function updateTransaction(value) {
                var transaction = transactionValueModify(value);
                TransactionService.update({ 'transactionId': value._id }, transaction).$promise.then(function () {
                    toaster.pop('success', 'Update', 'Transaction Updated Successfully.');
                    $scope.getResults();
                    $scope.transactionGroupModal = false;
                    $scope.transaction.trans = '';
                    $scope.payBills = [];
                })
            }

            $scope.deleteTransaction = function (transaction) {
                $scope.isSystemGenrated = (!!transaction.billInvoiceNumber || !!transaction.invoiceNumber);
                $scope.PopupHeading = 'Delete Transaction';
                ngDialog.openConfirm({
                    template: 'accounting/views/tmpl/confirmationPopup.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm'
                }).then(function (value) {
                    transaction.isDeleted = true;
                    transaction.username = $scope.user.username;
                    TransactionService.update({ 'transactionId': transaction._id }, transaction).$promise.then(function () {
                        toaster.pop('success', 'Delete', 'Transaction Deleted Successfully.');
                        $scope.getResults();
                    })
                }, $scope.getResults);
            }


            $scope.editTransaction = function (transaction) {
                var selectedGroupModal = accountingConstant.transactionModal.filter((item) => item.tranType === transaction.transactionType)[0];
                transaction.isNew = false;
                $scope.OnEditModal(selectedGroupModal, transaction);
                $scope.transaction = transaction
                console.log(transaction);
                var tmpl = (transaction.transactionType == 'ReceivePayment')?
                    'accounting/views/transactions/modals/receive_payment_modal.html':
                    'accounting/views/transactions/modals/transactions_modal.html';
                ngDialog.openConfirm({
                    template: tmpl,
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                    width: selectedGroupModal.modal === 'Customer' ? 1000 : 900,
                    onOpenCallback: function () {
                        $scope.modalOpen = {
                            isOpen: false
                        }
                        setTimeout(function () {
                            angular.element(':focus').blur();
                        })
                    }
                }).then(function (value) {
                    if (value.reoccurring) {
                        value.reoccurringDate = getReoccuringDate(value);
                    }
                    updateTransaction(value);
                }, function () {
                    $scope.getResults();
                    $scope.transactionGroupModal = false;
                    $scope.transaction.trans = '';
                    $scope.payBills = [];
                });
            }

            $scope.cleanRefs = function() {
                TransactionService.query({}, function (transactions) {
                    transactions.forEach(function(tran) { 
                        if(tran.referenceNo) {
                            tran.referenceNo = tran.referenceNo.replace('#', '');
                            tran.$update();
                        }
                    });
                });
            }

            $scope.OnEditModal = function (selectedGroupModal, transactionObj) {
                $scope.modalType = selectedGroupModal.tranType;
                $scope.modalName = selectedGroupModal.name;
                $scope.transRef = selectedGroupModal.modal;

                if ($scope.modalType === 'PayBill') {
                    TransactionBillsService.query({ clientAccountId: $scope.main_accountId, isPaid: false, transactionType: $scope.modalType }, function (bills) {
                        $scope.payBills = bills;
                    });
                }

                var currentChartQuery = {
                    type: 'TRAN_ACCOUNT',
                    isDeleted: false,
                    status: 'Active',
                    userId: $scope.main_accountId
                },
                    expenseAccount = angular.copy(currentChartQuery);
console.log(expenseAccount);
                if ($scope.transRef === 'Customer') {
                    if($scope.modalType != 'ReceivePayment')
                        currentChartQuery.parentOfAccountType = 'Current Assets';
                    if ($scope.modalType === 'Invoice') {
                        currentChartQuery.accountType = 'Account Receivable';
                    }
                }
                if ($scope.transRef === 'Vendor' || $scope.transRef === 'Employee' || $scope.modalType === 'PayrollBill') {
                    currentChartQuery.accountType = ['Bank', 'Credit Card'];
                    if ($scope.modalType === 'Bill' || $scope.modalType === 'PayrollBill') {
                        delete currentChartQuery.accountType;
                        currentChartQuery.accountType = 'Accounts Payable';
                        currentChartQuery.systemGenrated = true;
                    }
                }

                if ($scope.transRef === 'Vendor') {
                    expenseAccount.parentOfAccountType = 'Expenses';
                    if ($scope.modalType === 'PayBill') {
                        delete expenseAccount.parentOfAccountType;
                        expenseAccount.accountType = 'Accounts Payable';
                        expenseAccount.systemGenrated = true;
                    }
                }
                if ($scope.transRef === 'Customer') {
                    expenseAccount.parentOfAccountType = 'Income';
                    expenseAccount.systemGenrated = true;
                }

                console.log(currentChartQuery);

                Charts.query(currentChartQuery, function (accounts) {
                    var accounts = _.sortBy(accounts, ({ name }) => name.toLowerCase());
                    if ($scope.transRef !== 'Other') {
                        accounts = accounts.filter(function(item){
                            return item.detailType !== 'Retained Earnings'
                        });
                    }
                    $scope.currentAccounts = accounts;
                    if (transactionObj.paymentAccounts.length) {
                        transactionObj.paymentAccount = $scope.currentAccounts.filter(function (item) {
                            return item._id == transactionObj.paymentAccounts[0].paymentAccount._id;
                        })[0];
                    }
                    if ($scope.modalType === 'Transfer') {
                        transactionObj.expense[0].expenseAccount = $scope.currentAccounts.filter(function (item) {
                            return item._id == transactionObj.expense[0].expenseAccount._id;
                        })[0];
                    }
                    if($scope.modalType === 'ReceivePayment') {
                        $scope.expenseAccount = accounts;
                        // transactionObj.expense.map(function (item) {
                        //     item.expenseAccount = $scope.expenseAccount.filter(function (expense) {
                        //         return expense._id == item.expenseAccount._id;
                        //     })[0];
                        // })
                        console.log($scope.expenseAccount);
                    }
                    if ($scope.modalType === 'JournalEntry') {
                        $scope.expenseAccount = accounts;
                        transactionObj.expense.map(function (item) {
                            item.paymentAmount = 0;
                        });
                        transactionObj.paymentAccounts.map(function (item) {
                            var paymentObj = {
                                expenseAccount: item.paymentAccount,
                                expenseDescription: item.description,
                                expenseAmount: 0,
                                paymentAmount: item.paymentAmount,
                            }
                            transactionObj.expense.push(paymentObj)
                        })
                        transactionObj.expense.map(function (item) {
                            item.expenseAccount = $scope.expenseAccount.filter(function (expense) {
                                return expense._id == item.expenseAccount._id;
                            })[0];
                        })
                        console.log($scope.expenseAccount);
                    }
                });
                if ($scope.modalType !== 'JournalEntry' && $scope.modalType !== 'Transfer' && $scope.modalType !== 'ReceivePayment') {
                    Charts.query(expenseAccount, function (accounts) {
                        var accounts = _.sortBy(accounts, ({ name }) => name.toLowerCase());
                        if ($scope.transRef !== 'Other') {
                            accounts = accounts.filter(function(item){
                                return item.detailType !== 'Retained Earnings'
                            });
                        }
                        $scope.expenseAccount = accounts;
                        transactionObj.expense.map(function (item) {
                            item.expenseAccount = $scope.expenseAccount.filter(function (expense) {
                                return expense._id == item.expenseAccount._id;
                            })[0];
                        })
                    });
                }
                if (transactionObj.payee) {
                    transactionObj.payee = $scope.vendors.filter(function (item) {
                        return item._id == transactionObj.payee._id;
                    })[0];
                }
                if (transactionObj.user) {
                    transactionObj.user = $scope.users.filter(function (item) {
                        return item._id == transactionObj.user._id;
                    })[0];
                }
                if (transactionObj.customer) {
                    transactionObj.customer = $scope.customers.filter(function (item) {
                        return item._id == transactionObj.customer._id;
                    })[0];
                }
                if (transactionObj.reoccurringType) {
                    transactionObj.reoccurringType = $scope.reoccurringType.filter(function (item) {
                        return item.key == transactionObj.reoccurringType;
                    })[0];
                }
                if (transactionObj.project) {
                    transactionObj.job = $scope.all_projects.filter(function (item) {
                        return item._id == transactionObj.project.projectID;
                    })[0];
                    transactionObj.phase = transactionObj.project.phase;
                    transactionObj.type = transactionObj.project.type;
                }
                transactionObj.dueDate = moment(transactionObj.dueDate);
                transactionObj.date = moment(transactionObj.date);
                getReoccuringDateOnEdit(transactionObj);
            }

            /**
             * @description retutn next transactionObj date
             * @returns transactionObj dates in array
             */
            function getReoccuringDateOnEdit(transactionObj) {
                if (transactionObj.reoccurringType) {
                    $scope.reoccurringWatch();
                    if (transactionObj.reoccurringType.Type == 'W') {
                        var day = moment(transactionObj.reoccurringDates[0]).day();
                        transactionObj.weekDays = $scope.weekDays.filter(function (item) {
                            return item.id == day
                        })[0];
                    }
                    if (transactionObj.reoccurringType.Type == 'M') {
                        var date = moment(transactionObj.reoccurringDates[0]).date();
                        transactionObj.reoccurringDate = $scope.currentMonthDates.filter(function (item) {
                            return item.date == date;
                        })[0];
                    }
                    if (transactionObj.reoccurringType.key == 'twicePerMonth') {
                        var date1 = moment(transactionObj.reoccurringDates[0]).date(),
                            date2 = moment(transactionObj.reoccurringDates[1]).date();
                        if (date1 > 15) {
                            var temp = date1;
                            date1 = date2;
                            date2 = temp;
                        }
                        transactionObj.date1 = $scope.firstFiftenDates.filter(function (item) {
                            return item.date == date1;
                        })[0];

                        transactionObj.date2 = $scope.secondFiftenDates.filter(function (item) {
                            return item.date == date2;
                        })[0];
                    }
                    if (transactionObj.reoccurringType.Type == 'Y') {
                        var date = moment(transactionObj.reoccurringDates[0]).date(),
                            month = moment(transactionObj.reoccurringDates[0]).month();
                        transactionObj.month = $scope.monthsList.filter(function (item) {
                            return item.id == month;
                        })[0];
                        transactionObj.reoccurringDate = $scope.currentMonthDates.filter(function (item) {
                            return item.date == date;
                        })[0];
                    }
                }
            }

            $scope.editRate = function (bills) {
                bills.rateEditing = true;
            };

            $scope.doneRateEditing = function (item) {
                $scope.billError = false
                if (item.totalPayAmount > item.OpenBalance) {
                    $scope.billError = 'Payment amount should not be greater than Open Balance'
                }
                if (!item.rateEditing) return;
                item.rateEditing = false;
                $scope.totalAmountPaid();
            }

            $scope.donePaymentEditing = function (item) {
                $scope.billError = false
                if (item.totalPaymentAmount1 <= 0) {
                    $scope.billError = 'Payment amount should be greater than 0'
                }
                if (!item.rateEditing) return;
                item.rateEditing = false;
            }
            function createMultipleTransaction(transaction) {
                var result = [],
                    map = new Map();
                for (var item of transaction.bills) {
                    if ($scope.modalType === 'PayPayrollBill') {
                        item.payee._id = item.user._id;
                    }
                    var payee = item.payee._id;
                    if (!map.has(payee)) {
                        map.set(payee, true);
                        item.payBillPayment = [{
                            transactionId: item._id,
                            paidAmount: item.totalPayAmount
                        }]
                        delete item._id;
                        delete item.date;
                        delete item.dueDate;
                        delete item.createdDate;
                        item.transactionType = $scope.modalType;
                        item.paymentAccounts = [{
                            paymentAccount: transaction.paymentAccount._id,
                            name: transaction.paymentAccount.name,
                            paymentAmount: item.totalPayAmount
                        }];
                        item.expense = [{
                            expenseAccount: $scope.expenseAccount[0]._id,
                            name: $scope.expenseAccount[0].name,
                            expenseAmount: item.totalPayAmount
                        }]
                        item.paymentType = transaction.paymentType;
                        item.date = transaction.date;
                        item.totalExpenseAmount = item.totalPayAmount;
                        item.totalPaymentAmount = item.totalPayAmount;
                        result.push(item);
                    } else {
                        var length = result.length - 1;
                        result[length].payBillPayment.push({
                            transactionId: item._id,
                            paidAmount: item.totalPayAmount
                        })
                        result[length].paymentAccounts[0].paymentAmount = result[length].paymentAccounts[0].paymentAmount + item.totalPayAmount;
                        result[length].expense[0].expenseAmount = result[length].expense[0].expenseAmount + item.totalPayAmount;
                        result[length].totalExpenseAmount = result[length].expense[0].expenseAmount;
                        result[length].totalPaymentAmount = result[length].paymentAccounts[0].paymentAmount;
                    }

                }
                if ($scope.modalType === 'PayPayrollBill') {
                    result.map(function (item) {
                        item.user._id = item.payee._id;
                        delete item.payee._id;
                    })
                }
                TransactionService.bulkAdd(result, function () {
                    toaster.pop('success', 'Payment', 'Payment Done Successfully.');
                    $scope.getResults();
                    $scope.transactionGroupModal = false;
                    $scope.transaction.trans = '';
                    $scope.payBills = [];
                });

            }

            function billUpdateTransaction(transaction) {
                var transactionUpdateObj = transaction.bills.map(function (items) {
                    var transObj = {}
                    transObj = items;
                    transObj.isPaid = true;
                    transObj.totalPaymentAmount = items.totalPaymentAmount + items.totalPayAmount;
                    if (transObj.totalPaymentAmount < transObj.totalExpenseAmount) {
                        transObj.isPaid = false;
                    }
                    return transObj;
                });
                return transactionUpdateObj
            }

            $scope.message = "";
            $scope.ConvertToCSV = function (objArray) {
                var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
                var str = 'Date, Transaction Type, Name, Debit Account, Name, Credit Account, Ref No, Memo, Amount';
                str += '\r\n';
                for (var i = 0; i < array.length; i++) {
                    str += (moment(array[i].date).format('MM/DD/YYYY') || '') + ', ' + ((array[i].transactionType) || '') + ', ' + ((array[i]['payee'] || array[i]['user'] || {})['name'] || '') + ',';
                    str += (array[i].uniqueExpenses.length > 1 ? 'Account Split' : array[i].uniqueExpenses[0] ? array[i].uniqueExpenses[0].expenseAccount.name : '') + ', ';
                    str += (array[i]['customer'] ? array[i]['customer']['name'] : '') + ', ';
                    str += ((array[i].uniquePayments.length > 1) ? 'Account Split' : array[i].uniquePayments[0] ? array[i].uniquePayments[0].paymentAccount.name : ' ') + ',';
                    str += (array[i].referenceNo || '') + ', ' + (array[i].memo || '') + ', ' + ((array[i].totalExpenseAmount) || 0);
                    str += '\r\n';
                }
                var uri = encodeURIComponent(str);
                return uri;
            };

            $scope.exportFile = function () {
                var dataUrl = 'data:text/csv;charset=utf-8,' + ($scope.ConvertToCSV($scope.transactionList));
                var link = document.createElement('a');
                angular.element(link)
                    .attr('href', dataUrl)
                    .attr('download', 'transaction_report.csv'); // Pretty much only works in chrome
                link.click();
            };

            $scope.table = function (data, columns) {
                return [{
                    layout: 'lightHorizontalLines',
                    margin: [60, 0, 0, 0],
                    table: {
                        headerRows: 1,
                        widths: [100, 100, 50, 50, 50, 50, 50, 50, 50],
                        body: $scope.buildTableBody(data, columns)
                    },
                    fontSize: 10
                }];
            };

            $scope.buildTableBody = function (data, columns) {
                var body = [];
                body.push(columns.map(e => $scope.pdfHeadings[e]));
                _.each(data, function (row) {
                    var dataRow = [];
                    _.each(columns, function (column) {
                        var col = {};
                        switch (column) {
                            case 'transaction':
                                col = row['transactionType'] || '';
                                break;
                            case 'fromName':
                                col = (row['payee'] || row['user'] || {})['name'] || '';
                                break;
                            case 'creditAccount':
                                col = (row['uniquePayments']['length'] > 1 ? 'Account Split' : row['uniquePayments'][0] ? row['uniquePayments'][0]['paymentAccount']['name'] : '') || '';
                                break;
                            case 'toName':
                                col = (row['customer'] || {})['name'] || '';
                                break;
                            case 'debitAccount':
                                col = (row['uniqueExpenses']['length'] > 1 ? 'Account Split' : row['uniqueExpenses'][0]['expenseAccount']['name']) || '';
                                break;
                            case 'refNo':
                                col = row['referenceNo'] || '';
                                break;
                            case 'amount':
                                col = row['totalExpenseAmount'] || 0;
                                break;
                            case 'date':
                                col = moment(row['date']).format('MM/DD/YYYY') || '';
                                break;
                            default:
                                col = row[column] || '';
                                break;
                        }

                        dataRow.push(col);

                    })
                    body.push(dataRow);
                });
                return body;
            };

            $scope.buildPDF = function () {

                var tableData, fileName, header_title, sub_header, emailMessage;
                var companyName = $scope.companyName;
                var pdfHeaderKeys = ['date', 'transaction', 'fromName', 'debitAccount',
                    'toName', 'creditAccount', 'refNo', 'memo', 'amount'];
                var pageOri = 'landscape';

                sub_header = ' As Of ' + moment($scope.startDate).format('MMM DD, YYYY - ');
                sub_header += moment($scope.endDate).format('MMM DD, YYYY');
                emailMessage = 'Report on the ' + moment().format('MMM DD, YYYY.');

                header_title = 'Transaction Report';
                tableData = $scope.table($scope.transactionList, pdfHeaderKeys);
                fileName = 'transaction-report.pdf';

                emailMessage += '<br/><br/>' + header_title + sub_header;
                emailMessage += '<br/>' + 'Please find your report is attached.<br/><br/>';

                var pdfDataBody = {
                    pageMargins: [10, 20, 10, 20],
                    pageSize: 'A4',
                    Roboto: {
                        normal: 'Roboto-Regular.ttf',
                        bold: 'Roboto-Medium.ttf',
                        italics: 'Roboto-Italic.ttf',
                        bolditalics: 'Roboto-Italic.ttf'
                    },
                    header: [],
                    pageOrientation: pageOri,
                    content: [
                        {
                            alignment: 'center',
                            margin: [0, 0, 0, 10],
                            text: companyName,
                            style: 'company'
                        },
                        {
                            alignment: 'center',
                            margin: [0, 0, 0, 10],
                            text: header_title,
                            style: 'header'
                        },
                        {
                            alignment: 'center',
                            margin: [0, 0, 0, 10],
                            text: sub_header,
                            style: 'subHeader'
                        },
                        tableData,
                        ' ',
                        ' '
                    ],
                    styles: {
                        company: {
                            fontSize: 15,
                            bold: true
                        },
                        header: {
                            fontSize: 12,
                            bold: true
                        },
                        subHeader: {
                            fontSize: 10,
                            bold: true
                        }
                    },
                    defaultStyle: {
                        font: 'Roboto'
                    }
                }

                if ($scope.just_print) {
                    pdfMake.createPdf(pdfDataBody).open();
                    $scope.just_print = false;
                } else {

                    pdfMake.createPdf(pdfDataBody).getBase64(function (buffer) {
                        var data = ({
                            to: $scope.senderEmail.join(','),
                            from: header_title,
                            subject: header_title,
                            message: emailMessage +
                                '<b/><br/>This report is created using A.C.E. Construction Software.<br>' +
                                'Please do not reply to this email and contact the contractor ' +
                                'if you have any questions.',
                            fileName: fileName,
                            attachment: buffer
                        });

                        $http.post('/api/sendReports', data).
                            success(function (data, status, headers, config) {
                                console.log('Message was successfully sent');
                            }).
                            error(function (data, status, headers, config) {
                                console.log('There was an error with the message');
                            });
                    });
                }
            }

            $scope.printList = function () {
                $scope.just_print = true;
                $scope.buildPDF();
            }

            /**
             * @description Update due date on selection of terms
             */
            $scope.updateDueDate = function () {
                switch ($scope.transaction.terms) {
                    case 'Net 15':
                        $scope.transaction.dueDate = moment().add(15, 'days');
                        break
                    case 'Net 30':
                        $scope.transaction.dueDate = moment().add(30, 'days');
                        break
                    case 'Net 60':
                        $scope.transaction.dueDate = moment().add(60, 'days');
                        break
                    default:
                        $scope.transaction.dueDate = moment();
                }
            }

            $scope.updateAccountDisable = function () {
                if ($scope.transaction.paymentAccount) {
                    $scope.currentAccounts.map(function (item) {
                        item.disabled = false
                        if ($scope.transaction.paymentAccount._id == item._id) {
                            item.disabled = true;
                        }
                    })
                }
            }

            $scope.addSelectedDisable = (expense, index) => {
                if ($scope.transaction.expense && $scope.transaction.expense[index]) {
                    $scope.expenseAccount.map(function (item) {
                        if (item._id === expense) {
                            item.disabled = true;
                        }
                    })
                }
            }

            $scope.reconciliationModal = () => {
                $scope.initReconciliationData();
                ngDialog.openConfirm({
                    template: 'accounting/views/transactions/modals/reconciliation_modal.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg',
                    width: 650,
                    onOpenCallback: function () {
                        $scope.modalOpen = {
                            isOpen: false
                        }
                        $scope.reconciliationData.date = moment($scope.selReconcilate.endDate).startOf('day');
                        $scope.reconciliationData.minDate = moment($scope.selReconcilate.startDate);
                        $scope.reconciliationData.maxDate = moment($scope.selReconcilate.endDate);
                        setTimeout(function () {
                            angular.element(':focus').blur();
                        })
                    }
                }).then(function (value) {

                    var transactionAmt = Number(value.totalExpenseAmount) > 0 ? Number(value.totalExpenseAmount)
                        : Number(value.totalPaymentAmount);

                    var paymentAccounts = [{
                        paymentAccount: $scope.recFilter.account._id,
                        name: $scope.recFilter.account.name,
                        paymentAmount: transactionAmt,
                        matched: false,
                        hasRef: true,
                        refrence: value.refrence,
                        reason: value.reason,
                        diffAmt: value.diffAmt
                    }];

                    var expense = [{
                        expenseAccount: $scope.reconciliationData.selectedAccount._id,
                        name: $scope.reconciliationData.selectedAccount.name,
                        expenseAmount: transactionAmt,
                        paidAmount: transactionAmt,
                        matched: false,
                        hasRef: true,
                        refrence: value.refrence,
                        reason: value.reason,
                        diffAmt: value.diffAmt
                    }];

                    if (value.totalExpenseAmount > 0) {
                        paymentAccounts[0].paymentAccount = $scope.reconciliationData.selectedAccount._id;
                        paymentAccounts[0].name = $scope.reconciliationData.selectedAccount.name;

                        expense[0].expenseAccount = $scope.recFilter.account._id;
                        expense[0].name = $scope.recFilter.account.name;
                    }

                    var transObj = {
                        clientAccountId: $scope.main_accountId,
                        userId: $scope.main_accountId,
                        transactionType: 'JournalEntry',
                        transactionRef: 'Other',
                        paymentAccounts: paymentAccounts,
                        date: value.date,
                        referenceNo: value.referenceNo,
                        totalExpenseAmount: value.totalExpenseAmount,
                        totalPaymentAmount: value.totalPaymentAmount,
                        expense: expense,
                        memo: value.memo,
                        missingTrans: true,
                        isPaid: true,
                        systemGenrated: false
                    };

                    if (value.payee) {
                        transObj['payee'] = value.payee._id;
                        transObj.terms = value.payee.terms;
                        transObj.dueDate = moment(value.payee.asOf);
                        if (!transObj.payee.asOf) {
                            switch (transObj.terms) {
                                case 'Net 15':
                                    transObj.dueDate = moment().add(15, 'days');
                                    break
                                case 'Net 30':
                                    transObj.dueDate = moment().add(30, 'days');
                                    break
                                case 'Net 60':
                                    transObj.dueDate = moment().add(60, 'days');
                                    break
                                default:
                                    transObj.dueDate = moment();
                            }
                        }
                    } else if (value.customer) {
                        transObj['customer'] = value.customer._id;
                    }

                    var transaction = new TransactionService(transObj);
                    transaction.$save(function (savedData) {
                        $scope.selReconcilate.missingTransactions.push(savedData._id);
                        $scope.selReconcilate.$update(function (doc) {
                            $scope.getReconTransactions();
                            toaster.pop('success', 'Added', 'Missing Transaction Added Successfully.');
                            $scope.reconciliationData = null;
                        });
                    });
                });
            };

            $scope.initReconciliationData = function () {

                $scope.reconciliationData = {
                    selectedAccount: null,
                    totalExpenseAmount: 0,
                    totalPaymentAmount: 0,
                    debitDisable: false,
                    creditDisable: false,
                    payee: null,
                    customer: null,
                    referenceNo: '',
                    memo: '',
                    refrence: '',
                    reason: '',
                    diffAmt: '',
                    date: moment().subtract(1, 'days')
                };

                var currentCharQuery = {
                    type: 'TRAN_ACCOUNT', isDeleted: false, status: 'Active',
                    userId: $scope.main_accountId
                };

                var expenseAccount = angular.copy(currentCharQuery);

                $scope.reconciliationData.errorCurrent = false;
                $scope.reconciliationData.errorExpense = false;

                // Get current Account
                Charts.query(currentCharQuery, function (accounts) {
                    var accounts = _.sortBy(accounts, ({ name }) => name.toLowerCase());
                    $scope.currentAccounts = accounts;
                    if ($scope.currentAccounts.length < 1) {
                        $scope.reconciliationData.errorCurrent = true;
                    }
                });

                // Get current expense account
                Charts.query(expenseAccount, function (accounts) {
                    var accounts = _.sortBy(accounts, ({ name }) => name.toLowerCase());
                    $scope.expenseAccount = accounts;
                    if ($scope.expenseAccount.length < 1) {
                        $scope.reconciliationData.errorExpense = true;
                    }
                });
            }

            $scope.updateRecExpenceAmt = (creditAmount) => {
                $scope.reconciliationData.totalExpenseAmount = Number(creditAmount) > 0 ? Number(creditAmount) : 0;
                $scope.reconciliationData.debitDisable = Number(creditAmount) > 0;
            }

            $scope.updateRecPaymentAmt = (paymentAmount) => {
                $scope.reconciliationData.totalPaymentAmount = Number(paymentAmount) > 0 ? Number(paymentAmount) : 0;
                $scope.reconciliationData.creditDisable = Number(paymentAmount) > 0;
            }

            $scope.toggleReference = function (transaction, objType, index) {
                if (objType === 'expense') {
                    transaction['expense'][index]['hasRef'] = true;
                    transaction['expense'][index]['matched'] = false;
                    transaction['expense'][index]['reason'] = '';
                    transaction['expense'][index]['refrence'] = '';
                    transaction['expense'][index]['diffAmt'] = 0;
                } else {
                    transaction['paymentAccounts'][index]['hasRef'] = true;
                    transaction['paymentAccounts'][index]['matched'] = false;
                    transaction['paymentAccounts'][index]['reason'] = '';
                    transaction['paymentAccounts'][index]['refrence'] = '';
                    transaction['paymentAccounts'][index]['diffAmt'] = 0;
                }
            }

            $scope.updateMatch = function (transaction, objType, isChecked, deleteRefId, index) {
                if (objType === 'expense') {
                    transaction['expense'][index]['matched'] = isChecked;
                    transaction['expense'][index]['hasRef'] = false;
                    transaction['expense'][index]['reason'] = '';
                    transaction['expense'][index]['refrence'] = '';
                    transaction['expense'][index]['diffAmt'] = 0;
                } else {
                    transaction['paymentAccounts'][index]['matched'] = isChecked;
                    transaction['paymentAccounts'][index]['hasRef'] = false;
                    transaction['paymentAccounts'][index]['reason'] = '';
                    transaction['paymentAccounts'][index]['refrence'] = '';
                    transaction['paymentAccounts'][index]['diffAmt'] = 0;
                }

                if (isChecked) {
                    TransactionService.query({ reconcilateId: deleteRefId, type: 'withMissingTrans' }, function (res) {
                        if (res.length) {
                            res[0].$remove(function () {
                                $scope.updateReconcilateObj(transaction);
                            });
                        } else {
                            $scope.updateReconcilateObj(transaction);
                        }
                    });
                } else {
                    $scope.updateReconcilateObj(transaction);
                }
            }

            $scope.updateReconcilateObj = function (transaction) {
                transaction.$update($scope.getReconTransactions);
            }

            $scope.updateReconcilateRes = function (trans, updatedObj, type, indexNo) {
                trans.$update(function (doc) {
                    if (updatedObj.reason === 'Statement Errors' || updatedObj.reason === 'Transactions Errors') {
                        $scope.createTrans(trans, type, updatedObj, indexNo)
                    } else {
                        TransactionService.query({
                            reconcilateId: updatedObj._id,
                            type: 'withMissingTrans'
                        }, function (res) {
                            if (res.length) {
                                res[0].$remove(function () {
                                    $scope.getReconTransactions();
                                });
                            } else {
                                $scope.getReconTransactions();
                            }
                        });
                    }
                });
            }

            $scope.backRecReport = function () {
                $scope.recFilter = {
                    account: '', sdate: '', beginBal: 0.00,
                    closingBal: 0.00, edate: ''
                };
                $scope.recDetailView = false;
                $scope.reconcileTrans = [];
                $scope.selReconcilate = null;
            }

            $scope.editReconciReport = function (selReport) {

                if (selReport.completed) { return; }

                var debitAccountIncrease = (accountType[0].name === selReport.accountId.parentOfAccountType)
                    || (accountType[0].name === selReport.accountId.parentOfParentAccountType)
                    || (accountType[4].name === selReport.accountId.parentOfAccountType)
                    || (accountType[4].name === selReport.accountId.parentOfParentAccountType);
console.log('editReconciReport');
                $scope.recFilter = {
                    account: selReport.accountId,
                    sdate: moment(selReport.startDate),
                    beginBal: Number(selReport.begningBalance),
                    closingBal: Number(selReport.closingBalance),
                    edate: moment(selReport.endDate),
                    debitIncrease: debitAccountIncrease
                };

                $scope.selAccountId = $scope.recFilter.account._id;
                $scope.selReconcilate = selReport;
                $scope.getReconTransactions();
            }

            $scope.getRefrences = function (transac) {
                let refences = [];
                let allTransactions = [];
                allTransactions = transac.missingTransactions.concat(transac.refrenceTransactions);
                allTransactions = allTransactions.filter(function(item){
                    return !item.isDeleted;
                })
                _.each(allTransactions, function (item) {

                    _.each(item.paymentAccounts, function (pay) {
                        if ((pay.paymentAccount._id == transac.accountId._id
                            || pay.paymentAccount == transac.accountId._id)
                            && pay.hasRef && pay.refrence) {
                            refences.push(pay.refrence);
                        }
                    });

                    _.each(item.expense, function (exp) {
                        if ((exp.expenseAccount._id == transac.accountId._id
                            || exp.expenseAccount == transac.accountId._id)
                            && exp.hasRef && exp.refrence) {
                            refences.push(exp.refrence);
                        }
                    });
                });
                refences = [...new Set(refences)];
                return refences.join(',');
            }

            $scope.completeReport = function () {
                if ($scope.selReconcilate.completed) {
                    toaster.pop('error', 'Adready Submitted Error', 'Report has been submitted already.');
                    return;
                }

                var reconcileTrans = [];
                var missingACTrans = [];

                _.each($scope.reconcileTrans, function (item) {
                    reconcileTrans.push(item._id);
                });

                _.each($scope.missingACTrans, function (item) {
                    missingACTrans.push(item._id);
                });

                $scope.selReconcilate.refrenceTransactions = reconcileTrans;
                $scope.selReconcilate.missingTransactions = missingACTrans;
                $scope.selReconcilate.completed = true;
                $scope.selReconcilate.$update(function (doc) {
                    $scope.recDetailView = false;
                });
            }

            $scope.createTrans = function (transaction, type, transObj, indexNo) {
                $scope.recSecondSection = true;
                TransactionService.query({ reconcilateId: transObj._id, type: 'withMissingTrans' }, function (res) {
                    if (res.length) {
                        var updObject = res[0];
                        updObject.expense[0].expenseAmount = Number(transObj.diffAmt);
                        updObject.expense[0].paidAmount = Number(transObj.diffAmt);
                        updObject.paymentAccounts[0].paymentAmount = Number(transObj.diffAmt);

                        if (type === 'expense') {
                            updObject.expense[0].diffAmt = Number(transObj.diffAmt);
                            updObject.expense[0].reason = transaction.expense[indexNo].reason;
                            updObject.expense[0].refrence = transaction.expense[indexNo].refrence;
                        } else {
                            updObject.paymentAccounts[0].diffAmt = Number(transObj.diffAmt);
                            updObject.paymentAccounts[0].reason = transaction.paymentAccounts[indexNo].reason;
                            updObject.paymentAccounts[0].refrence = transaction.paymentAccounts[indexNo].refrence;
                        }

                        updObject.totalExpenseAmount = Number(transObj.diffAmt);
                        updObject.totalPaymentAmount = Number(transObj.diffAmt);

                        updObject.$update(function (doc) {
                            if (type === 'expense') {
                                transaction.expense[indexNo].diffAmt = Number(transObj.diffAmt);
                            } else {
                                transaction.paymentAccounts[indexNo].diffAmt = Number(transObj.diffAmt);
                            }
                            transaction.$update($scope.getReconTransactions);
                        });
                    } else {
                        var newObject = JSON.parse(JSON.stringify(transaction));
                        delete newObject._id;
                        delete newObject.__v;
                        if (type === 'expense') {
                            var expense = [{
                                expenseAccount: null,
                                name: null,
                                expenseDescription: '',
                                expenseAmount: Number(transObj.diffAmt),
                                paidAmount: Number(transObj.diffAmt),
                                matched: false,
                                hasRef: true,
                                refrence: transObj.refrence,
                                reason: transObj.reason,
                                diffAmt: 0
                            }];

                            var payment = [{
                                paymentAccount: null,
                                name: null,
                                paymentAmount: Number(transObj.diffAmt),
                                description: '',
                                matched: false,
                                hasRef: true,
                                refrence: '',
                                reason: '',
                                diffAmt: 0
                            }];

                            // set chart of account according to dabit and credit
                            var paymentAcId = transaction.paymentAccounts[0].paymentAccount._id || transaction.paymentAccounts[0].paymentAccount;
                            var expenseAcId = transObj.expenseAccount._id || transObj.expenseAccount;
                            payment[0].paymentAccount = paymentAcId;
                            payment[0].name = transaction.paymentAccounts[0].name;

                            expense[0].expenseAccount = expenseAcId;
                            expense[0].name = transObj.name;

                            newObject.expense = expense;
                            newObject.paymentAccounts = payment;

                        } else {
                            var expenseAcId = transaction.expense[0].expenseAccount._id || transaction.expense[0].expenseAccount;

                            var expense = [{
                                expenseAccount: expenseAcId,
                                name: transaction.expense[0].name,
                                expenseDescription: '',
                                expenseAmount: Number(transObj.diffAmt),
                                paidAmount: Number(transObj.diffAmt),
                                matched: false,
                                hasRef: true,
                                refrence: '',
                                reason: '',
                                diffAmt: 0
                            }];

                            var payment = [{
                                paymentAccount: transObj.paymentAccount._id || transObj.paymentAccount,
                                name: transObj.name,
                                paymentAmount: Number(transObj.diffAmt),
                                description: '',
                                matched: false,
                                hasRef: true,
                                refrence: transObj.refrence,
                                reason: transObj.reason,
                                diffAmt: 0
                            }];

                            newObject.expense = expense;
                            newObject.paymentAccounts = payment;
                        }

                        newObject.reconcilateId = transObj._id;
                        newObject.totalExpenseAmount = Number(transObj.diffAmt);
                        newObject.totalPaymentAmount = Number(transObj.diffAmt);
                        newObject.missingTrans = true,
                            newObject.totalPaymentAmount = 0;
                        var newRecon = new TransactionService(newObject);
                        newRecon.$save(function (savedDoc) {
                            if (type === 'expense') {
                                transaction.expense[indexNo].diffAmt = Number(transObj.diffAmt);
                            } else {
                                transaction.paymentAccounts[indexNo].diffAmt = Number(transObj.diffAmt);
                            }
                            transaction.$update($scope.getReconTransactions);
                        });
                    }
                });
            }

            $scope.getReconTransactions = function () {
                $scope.refrenceTransaction = [];
                !$scope.recDetailView && ($scope.recDetailView = true);
                $scope.recSecondSection && ($scope.recSecondSection = false);
console.log('getReconTransactions');
                var searchProperties = {
                    clientAccountId: $scope.main_accountId,
                    paymentAccounts: $scope.recFilter.account ? $scope.recFilter.account._id : undefined,
                    startDate: $scope.recFilter.sdate ? moment($scope.recFilter.sdate).startOf('day').toDate() : undefined,
                    endDate: $scope.recFilter.edate ? moment($scope.recFilter.edate).endOf('day').toDate() : undefined,
                    isDeleted: false,
                    type: 'withMissingTrans'
                }
                TransactionService.query(searchProperties, function (transactions) {
                    $scope.allTransactins = transactions;
                    $scope.missingACTrans = _.filter(transactions,['missingTrans', true]);
                    
                    $scope.reconcileTrans = _.filter(transactions,['missingTrans', false]);
                    calAdjustedAmount();
                });
            }

            function calAdjustedAmount() {
                var allTransactions = [];
                allTransactions = $scope.allTransactins;

                var newReportData = angular.copy(accountingConstant.reconcilateData);

                // Statement Unadjusted Closing Balance
                newReportData[0].value = Number($scope.selReconcilate.closingBalance);
                for (var i = 1; i <= 3; i++) {
                    calculationHeadTotal(newReportData[i], allTransactions, false);
                    newReportData[10].value += Number(newReportData[i].value);
                }

                // ACE Transaction Unadjusted Closing Balance
                newReportData[4].value = Number($scope.selReconcilate.begningBalance);
                for (var j = 5; j <= 9; j++) {
                    calculationHeadTotal(newReportData[j], allTransactions, false);
                    newReportData[11].value += Number(newReportData[j].value);
                }
                calculationHeadTotal(newReportData[4], $scope.reconcileTrans, true);

                newReportData[11].value += Number(newReportData[4].value);

                // Adjusted Closing Balance Statement
                newReportData[10].value += Number(newReportData[0].value);

                // Adjusted Closing Balance Statement
                newReportData[12].value = Number(newReportData[10].value) - Number(newReportData[11].value);

                if(newReportData[12].value < 0.01) {
                    newReportData[12].value = 0;
                }

                $scope.reconcilateData = newReportData;
                $scope.refrenceTransaction = totalHasRefrence(allTransactions);
                $scope.disabled = $scope.refrenceTransaction.reduce((a,b)=> (a[b]=true,a),{});
                $scope.selReconcilate.refrenceTransactions = $scope.reconcileTrans;
                $scope.selReconcilate.missingTransactions = $scope.missingACTrans;
                $scope.selReconcilate.$update();
            }
        
            function totalHasRefrence (allTransactions) {
                var hasTransacRef = [],
                    allChecked = [];
                    $scope.referencedTransaction = []
                _.each(allTransactions, function (trans) {
                    if (trans.missingTrans) {
                        $scope.referencedTransaction.push(trans);
                    }
                    trans.paymentAccounts.map(function (item) {
                        if (item.paymentAccount._id == $scope.selAccountId) {
                            if (item.hasRef) {
                                hasTransacRef.push(item.refrence);
                                if (!trans.missingTrans && item.diffAmt == 0) {
                                    $scope.referencedTransaction.push(trans);
                                }
                            }
                            allChecked.push(item.hasRef || item.matched);
                        }
                    });
                    trans.expense.map(function (item) {
                        if (item.expenseAccount._id == $scope.selAccountId) {
                            if (item.hasRef ) {
                                hasTransacRef.push(item.refrence);
                                if (!trans.missingTrans && item.diffAmt == 0) {
                                    $scope.referencedTransaction.push(trans);
                                }
                            }
                            allChecked.push(item.hasRef || item.matched);
                        }
                    });
                })
                $scope.allChecked = allChecked.includes(false);
                return hasTransacRef;
            }

            function calculationHeadTotal (newReportData, allTransactions, isStmtBegBal) {
                _.each(allTransactions, function (item) {

                    var debitAmount = 0;
                    var creditAmount = 0;

                    var payment = item.paymentAccounts.filter(function (pay) {
                        var errorCond = true;
                        if (newReportData.label == 'Transactions Errors' || newReportData.label == 'Statement Errors') {
                            errorCond = !!item.reconcilateId;
                        }
                        return (pay.paymentAccount._id == $scope.selAccountId && ((pay.reason === newReportData.label && errorCond) || isStmtBegBal));
                    });
                    if (payment.length) {
                        creditAmount = payment.reduce(function (p, c) {
                            if (!isStmtBegBal) { newReportData.refs.push(c.refrence); }
                            return Number(p) + Number(c.paymentAmount)
                        }, 0)
                    }
                    var expense = item.expense.filter(function (exp) {
                        var errorCond = true;
                        if (newReportData.label == 'Transactions Errors' || newReportData.label == 'Statement Errors') {
                            errorCond = !!item.reconcilateId;
                        }
                        return (exp.expenseAccount._id == $scope.selAccountId && ((exp.reason === newReportData.label && errorCond) || isStmtBegBal));
                    });
                    if (expense.length) {
                        debitAmount = expense.reduce(function (p, c) {
                            if (!isStmtBegBal) { newReportData.refs.push(c.refrence); }
                            return Number(p) + Number(c.expenseAmount)
                        }, 0)
                    }
                    newReportData.value += (!$scope.recFilter.debitIncrease ? (Number(creditAmount) - Number(debitAmount)) : (Number(debitAmount) - Number(creditAmount)));
                });
            }

            /**
             * @description import selected file
             */
            $scope.fileSelected = function () {
                var payload = {},
                    _self = this,
                    importedCsv = this.$parent.fileContent.split('\n'),
                    headerLength = importedCsv[0].split(',').length;
                    if (headerLength == 9) {
                        for (var i = 1 ; i < importedCsv.length - 1; i++) {
                            var l = importedCsv[i],
                                data = l.split(',');
                            if (!!data[0].trim()) {
                                if (new Date(data[0].trim()) !== 'Invalid Date') {
                                    data[0] = new Date(data[0].trim());
                                }
                            }
                            importedCsv[i] = data.join();
                        }
                    }
                payload.userId = $scope.main_accountId;
                payload.transactions = importedCsv;
                payload.trade = $scope.user.trade[0];
                payload.contractor_code = $scope.user.contractor_code;
                $http.post(importTransactionsAPI, payload).
                    success(function () {
                        toaster.pop('success', 'Data imported successfully.');
                        $scope.getAccounts();
                        delete _self.$parent.fileContent;
                    }).
                    error(function (error) {
                        var title = 'Rejected Import, fix, and retry.'
                        var message = '';
                        if (error.error.length) {
                            var linenumber = 0
                            error.error.map(function (error, index) {
                                linenumber = index + 1;
                                var errormsg = '<b>' + linenumber + '. ' + error + '.</b> <br><br>';
                                message = message.concat(errormsg);
                            });
                            var height = linenumber > 10 ? 500 : 50 * linenumber;
                            height = height + 'px';
                            message = '<div class="toster-msg-trans" style="height:' + height + '">' + message + '</div>'
                        } else {
                            message = error;
                        }
                        toaster.pop({
                            'type': 'error',
                            'title': title,
                            'body': message,
                            'bodyOutputType': 'trustedHtml',
                            'timeout': 0,
                            'showCloseButton': true
                        });
                        $scope.getAccounts();
                        delete _self.$parent.fileContent;
                    });
            };
            /**
             * @description Calculate accurate addition of number due to js floating number
             * @param {*} num1 
             * @param {*} num2 
             */
            function accurateCalc (num1, num2) {
                num1 = parseFloat(num1);
                num2 = parseFloat(num2);
                if (isNaN(num1) || isNaN(num2)) { // Values validation
                    return Number.NaN;
                }

                var strNum1 = num1 + '',
                    strNum2 = num2 + '',
                    dpNum1 = !!(num1 % 1) ? (strNum1.length - strNum1.indexOf('.') - 1) : 0, // Get total decimal places of num1
                    dpNum2 = !!(num2 % 1) ? (strNum2.length - strNum2.indexOf('.') - 1) : 0, // Get total decimal places of num2
                    multiplier = Math.pow(10, dpNum1 > dpNum2 ? dpNum1 : dpNum2), // Compare dpNum1 and dpNum2, then find value of 10 to the power of the largest between them.
                    tempNum1 = Math.round(num1 * multiplier), // Multiply num1 by multiplier to eliminate all decimal places of num1.
                    tempNum2 = Math.round(num2 * multiplier), // Multiply num2 by multiplier to eliminate all decimal places of num2.
                    result;
                result = (tempNum1 + tempNum2) / multiplier;
                return result;
            }

            /**
             * @description Delete Reconciliation Report
             * @param {object} trans
             */
            $scope.deleteReconciReport = function(trans) {
                $scope.PopupHeading = 'Delete Reconciliation Report';
                ngDialog.openConfirm({
                    template: 'accounting/views/tmpl/confirmationPopup.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm'
                }).then(function (value) {
                    trans.isDeleted = true;
                    ReconcileService.update({ 'docId': trans._id }, trans).$promise.then(function () {
                        var searchProperties = {
                            paymentAccounts: trans.accountId._id,
                            clientAccountId: $scope.main_accountId,
                            endDate: new Date(trans.endDate),
                            startDate: new Date(trans.startDate),
                            isDeleted: false,
                            type: 'withMissingTrans'
                        }
                        TransactionService.query( searchProperties, function (res) {
                            if (res.length) {
                                var transactionDelete = _.filter(res,['missingTrans', true]);
                                for (const element of transactionDelete) {
                                    element.$remove();
                                }
                                toaster.pop('success', 'Delete', ' Deleted Successfully.');
                            }
                            $scope.fetchReconReport();
                        })
                }, $scope.fetchReconReport);
                });

            }

            $scope.deleteRefrenceTransaction = function(trans) {
                $scope.PopupHeading = 'Delete Refrence Transaction';
                ngDialog.openConfirm({
                    template: 'accounting/views/tmpl/confirmationPopup.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-sm'
                }).then(function () {
                    var query = { _id: trans._id, type: 'withMissingTrans'};
                    TransactionService.query(query, function (res) {
                        if (res.length) {
                            if (res[0].missingTrans) {
                                var query1 = {reconcilationId: trans.reconcilateId}
                            } else {
                                query1 = query;
                            }
                            TransactionService.query( query1, function (res1) {
                                if (res1.length) {
                                    res1 = res1[0];
                                    res1.paymentAccounts.map(function(item) {
                                        if (item.paymentAccount._id == $scope.selAccountId) {
                                            item['hasRef'] = false;
                                            item['matched'] = false;
                                            item['reason'] = '';
                                            item['refrence'] = '';
                                            item['diffAmt'] = 0;
                                        }

                                    })
                                    res1.expense.map(function(item) {
                                        if (item.expenseAccount._id == $scope.selAccountId) {
                                            item['hasRef'] = false;
                                            item['matched'] = false;
                                            item['reason'] = '';
                                            item['refrence'] = '';
                                            item['diffAmt'] = 0;
                                        }

                                    })
                                    res1.$update();
                                    $scope.getReconTransactions();
                                }
                            })
                            if (res[0].missingTrans) {
                                $scope.selReconcilate.missingTransactions = $scope.selReconcilate.missingTransactions.filter(function(item){
                                    return item == trans._id;
                                });
                                $scope.selReconcilate.$update(function (doc) {
                                    res[0].$remove();
                                    toaster.pop('success', 'Delete', ' Deleted Successfully.');
                                    $scope.getReconTransactions();
                                });
                            }
                            
                            
                        }
                    })
                });
            }
        }
    ]);



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/transaction.js